import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import PropTypes from 'prop-types';
import { SortedRegTypeOrder } from 'components';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';

const columns = [
  {
    name: 'task',
    type: 'string',
    label: 'Task',
    align: 'left',
    filterable: true
  },
  {
    name: 'regType',
    type: 'string',
    label: 'Registration Types',
    align: 'left',
    filterable: true,
    renderCell: data => {
      const sortedArr = SortedRegTypeOrder(data.regType.split(', '));
      return (
        <div>
          {sortedArr && sortedArr.join(', ')}
        </div>
      );
    }
  }
];

const TaskAccess = ({ taskAccessData }) => (
  <div className="ml-3">
    <GridTable
      sortable
      tag={`${TE.ID}taskaccess${TE.TABLE}`}
      title="Task Access"
      exportTitle={`Task Access-${useGetPathProtocol()}-Integrations`}
      enableToolbar
      columns={columns}
      user={GetUserFullName()}
      rows={taskAccessData}
      defaultSorts={[{
        field: 'task',
        dir: 'asc'
      }]}
      toPdf={false}
    />
  </div>
);


TaskAccess.propTypes = {
  taskAccessData: PropTypes.oneOfType([PropTypes.array]).isRequired
};

export { TaskAccess };
